export default {
  data() {
    return {
      tagList: [],
      visitedViews: []
    };
  },
  props: {
    customize: {
      type: Object,
      default() {
        return {
          showBreadcrumb: false, // 是否显示面包屑，默认不显示
          visibleTagUpperLimit: 8, // 最大可显示的TAG数量，默认8
          disabled: false
        };
      }
    },
    customizeNavbar: {
      type: Object,
      default() {
        return {
        };
      }
    }
  },
  computed: {
    webview() {
      return this.$store.state.kiaf.webview;
    }
  },
  methods: {
    changePath(tag) {
      if(!this.customize.disabled && !this.customizeNavbar.disabled){
        if (tag.webviewParams) {
          this.$store.commit('KIAF_SET_WEBVIEW', tag.webviewParams);
          if(tag.url.indexOf('/kiaf/webview') >= 0){
            this.$router.push(tag.url);
          }
        } else {
          this.$store.commit('KIAF_INIT_WEBVIEW', {});
          this.$router.push(tag.url);
        }
      }
      if(this.customizeNavbar.handleOnTagClick && typeof this.customizeNavbar.handleOnTagClick === 'function'){
        this.customizeNavbar.handleOnTagClick(tag);
      }
    },
    isActive(tag) { //激活状态
      let result = false;
      if (tag.webviewParams) {
        if(this.webview.id === tag.id){
          result = true;
        } else if((this.webview.id && !isNaN(this.webview.id) && this.webview.id.toString().length === 13) || ((tag.id && !isNaN(tag.id) && tag.id.toString().length === 13))){ //考虑到兼容，对id是时间戳的，只比较url
          let tagUrl = tag.webviewParams.url ? tag.webviewParams.url.split('?')[0] : '0';
          let webviewUrl = this.webview.url ? this.webview.url.split('?')[0] : '1';
          result = (webviewUrl === tagUrl);
        } else {
          result = false;
        }
      } else if (!this.webview.url) {
        let matchPath = this.$route.fullPath;
        let tagUrl = tag.url;
        tagUrl = this.$util.getMatchPath(tagUrl);
        matchPath = this.$util.getMatchPath(matchPath);
        result = (tagUrl === matchPath);
        if(result){
          tag.url = this.$route.fullPath;//避免点击标签后缓存消失
        }
      }
      if(result){
        sessionStorage.setItem(this.$constants.STORAGE_KEY_LAST_ACTIVE_TAG, JSON.stringify(tag));
      }
      return result;
    },
    getActiveTag() { //获取当前激活标签
      let res = '';
      for (let i = 0, len = this.visitedViews.length; i < len; i++) {
        if (this.visitedViews[i].url === this.$route.path) {
          res = this.visitedViews[i];
          return res;
        }
      }
    },
    closeSelectedTag(view, index) { //关闭某个标签
      if(this.customize.disabled || this.customizeNavbar.disabled){
        return;
      }
      if (this.visitedViews.length === 1 || (this.visitedViews.some(x => x.title === this.$constants.KIAF_MENU_HOME_TITLE) && this.visitedViews.length === 2)) {
        //保留一个页签 或者 有首页的保留2个
        return;
      }
      for (let i = 0; i < this.tagList.length; i++) {
        if (this.visitedViews[index] == this.tagList[i]) {
          if(this.tagList[i].id){
            let data = {
              tagId: this.tagList[i].id,
              url: this.tagList[i].url
            };
            if(this.tagList[i].webviewParams){
              data.webview = true;
            }
            this.$postMessage(this.$constants.EVENT_BUS_CODE_REMOVE_TAG, Object.assign({}, view, this.tagList[i], data));
          }
          this.tagList.splice(i, 1);
          let tag = this.tagList[this.tagList.length - 1];
          if(!tag.webviewParams){
            this.$router.push(tag.url);
          }
          this.changePath(this.tagList[this.tagList.length - 1]);
          break;
        }
      }
    },
    goForward() {  //向前获取tab
      if (this.tagList[0] == this.visitedViews[0]) {
        return;
      }
      for (var i = 0; i < this.tagList.length; i++) {
        if (this.visitedViews[0] == this.tagList[i]) {
          if (this.tagList[i - 1]) {
            this.visitedViews.unshift(this.tagList[i - 1]);
          }
          this.visitedViews.pop();
          return;
        }
      }
    },
    goBack() {  //向后获取tab
      if (this.tagList[this.tagList.length - 1] == this.visitedViews[this.visitedViews.length - 1]) {
        return;
      }
      for (var i = 0; i < this.tagList.length; i++) {
        if (this.visitedViews[this.visitedViews.length - 1] == this.tagList[i]) {
          if (this.tagList[i + 1]) {
            this.visitedViews.push(this.tagList[i + 1]);
          }
          this.visitedViews.shift();
          return;
        }
      }
    }
  },
  created() {
    this.$onMessage(
      this.$constants.EVENT_BUS_CODE_REMOVE_TAGVIEW,
      menu => {
        if(menu.removeType == 'exclude'){ // 删除
          for(let i = this.visitedViews.length - 1; i >= 0; i--){
            let tag = this.visitedViews[i];
            if((menu.id && menu.id === tag.id) || (menu.sign && menu.sign === tag.sign) || (menu.title && menu.title === tag.title) || (menu.url && menu.url === tag.url)){
              // keep
            } else {
              this.closeSelectedTag(menu, i);
            }
          }
        } else {
          const index = this.visitedViews.findIndex(tag => (menu.id && menu.id === tag.id) || (menu.sign && menu.sign === tag.sign) || (menu.title && menu.title === tag.title) || (menu.url && menu.url === tag.url));
          this.closeSelectedTag(menu, index);
        }
      },
      this
    );
  },
  mounted() {
    this.tagList = this.$store.state.kiaf.tagList;
    if(this.tagList.length <= 0 || (this.tagList.length == 1 && this.tagList[0].id == 'kiaf-menu-home')){
      let tag = sessionStorage.getItem(this.$constants.STORAGE_KEY_LAST_ACTIVE_TAG);
      if(tag){
        try {
          tag = JSON.parse(tag);
          if(tag.title){
            this.tagList.push(tag);
          }
          if(tag.webviewParams){
            this.$store.commit('KIAF_SET_WEBVIEW', tag.webviewParams);
          }
        }catch (e) {
        }
      }
    }
  }

};
